export const BRANDS = {
    edostavka: [
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B1003%5D%7D',
            icon: '/assets/images/brands/1.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B378%5D%7D',
            icon: '/assets/images/brands/2.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B2534%5D%7D',
            icon: '/assets/images/brands/3.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B891%5D%7D',
            icon: '/assets/images/brands/4.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B32082%5D%7D',
            icon: '/assets/images/brands/5.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B365%5D%7D',
            icon: '/assets/images/brands/6.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B21980%5D%7D',
            icon: '/assets/images/brands/7.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B538%5D%7D',
            icon: '/assets/images/brands/8.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B11427%5D%7D',
            icon: '/assets/images/brands/9.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B10614%5D%7D',
            icon: '/assets/images/brands/10.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B3049%5D%7D',
            icon: '/assets/images/brands/11.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B2585%5D%7D',
            icon: '/assets/images/brands/12.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B1204%5D%7D',
            icon: '/assets/images/brands/13.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B36952%5D%7D',
            icon: '/assets/images/brands/14.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B28284%5D%7D',
            icon: '/assets/images/brands/15.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B36073%5D%7D',
            icon: '/assets/images/brands/16.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B356%5D%7D',
            icon: '/assets/images/brands/17.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B536%5D%7D',
            icon: '/assets/images/brands/18.png?v=18',
        },
        {
            url: '',
            icon: '/assets/images/brands/19.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B1239%5D%7D',
            icon: '/assets/images/brands/20.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B46250%5D%7D',
            icon: '/assets/images/brands/21.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B331%5D%7D',
            icon: '/assets/images/brands/22.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B945%5D%7D',
            icon: '/assets/images/brands/23.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B2779%5D%7D',
            icon: '/assets/images/brands/24.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B530%5D%7D',
            icon: '/assets/images/brands/25.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B372%5D%7D',
            icon: '/assets/images/brands/26.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B775%5D%7D',
            icon: '/assets/images/brands/27.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B9238%5D%7D',
            icon: '/assets/images/brands/28.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B777%5D%7D',
            icon: '/assets/images/brands/29.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B35679%5D%7D',
            icon: '/assets/images/brands/30.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B27427%5D%7D',
            icon: '/assets/images/brands/31.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B35918%5D%7D',
            icon: '/assets/images/brands/31-2.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B537%5D%7D',
            icon: '/assets/images/brands/32.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B39200%5D%7D',
            icon: '/assets/images/brands/33.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B1734%5D%7D',
            icon: '/assets/images/brands/34.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B330%5D%7D',
            icon: '/assets/images/brands/35.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B573%5D%7D',
            icon: '/assets/images/brands/36.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B33667%5D%7D',
            icon: '/assets/images/brands/37.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B10198%5D%7D',
            icon: '/assets/images/brands/38.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B39139%5D%7D',
            icon: '/assets/images/brands/39.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B24302%5D%7D',
            icon: '/assets/images/brands/40.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B609%5D%7D',
            icon: '/assets/images/brands/41.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B42577%5D%7D',
            icon: '/assets/images/brands/42.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B354%5D%7D',
            icon: '/assets/images/brands/43.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B51216%5D%7D',
            icon: '/assets/images/brands/44.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B22030%5D%7D',
            icon: '/assets/images/brands/45.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?filter=%7B%22trademarkIds%22%3A%5B41353%5D%7D',
            icon: '/assets/images/brands/46.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B867%5D%7D',
            icon: '/assets/images/brands/47.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B39551%5D%7D',
            icon: '/assets/images/brands/48.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B740%5D%7D',
            icon: '/assets/images/brands/49.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B798%5D%7D',
            icon: '/assets/images/brands/50.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B10181%5D%7D',
            icon: '/assets/images/brands/51.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B42581%5D%7D',
            icon: '/assets/images/brands/52.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?filter=%7B%22trademarkIds%22%3A%5B2824%5D%7D',
            icon: '/assets/images/brands/53.png?v=18',
        },
        {
            url: 'https://edostavka.by/actions/lucky-goods?lc=2&filter=%7B%22trademarkIds%22%3A%5B26873%5D%7D',
            icon: '/assets/images/brands/54.png?v=18',
        },
    ],
    emall: [
        {
            url: 'https://emall.by/actions/lucky-goods?brands=1003\n',
            icon: '/assets/images/brands/1.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=378\n',
            icon: '/assets/images/brands/2.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=2534\n',
            icon: '/assets/images/brands/3.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=891\n',
            icon: '/assets/images/brands/4.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=32082\n',
            icon: '/assets/images/brands/5.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=21980\n',
            icon: '/assets/images/brands/7.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=538\n',
            icon: '/assets/images/brands/8.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=11427\n',
            icon: '/assets/images/brands/9.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=10614\n',
            icon: '/assets/images/brands/10.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=2585\n',
            icon: '/assets/images/brands/12.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=1204\n',
            icon: '/assets/images/brands/13.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=36952\n',
            icon: '/assets/images/brands/14.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=28284\n',
            icon: '/assets/images/brands/15.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=36073\n',
            icon: '/assets/images/brands/16.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=356\n',
            icon: '/assets/images/brands/17.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=536\n',
            icon: '/assets/images/brands/18.png?v=18',
        },
        {
            url: '',
            icon: '/assets/images/brands/19.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=1239\n',
            icon: '/assets/images/brands/20.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=46250\n',
            icon: '/assets/images/brands/21.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=331\n',
            icon: '/assets/images/brands/22.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=945\n',
            icon: '/assets/images/brands/23.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=2779\n',
            icon: '/assets/images/brands/24.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=530\n',
            icon: '/assets/images/brands/25.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=372\n',
            icon: '/assets/images/brands/26.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=775\n',
            icon: '/assets/images/brands/27.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=9238\n',
            icon: '/assets/images/brands/28.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=777\n',
            icon: '/assets/images/brands/29.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=35679\n',
            icon: '/assets/images/brands/30.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=27427\n',
            icon: '/assets/images/brands/31.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=35918\n',
            icon: '/assets/images/brands/31-2.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=537\n',
            icon: '/assets/images/brands/32.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=39200\n',
            icon: '/assets/images/brands/33.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=1734\n',
            icon: '/assets/images/brands/34.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=330\n',
            icon: '/assets/images/brands/35.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=10198\n',
            icon: '/assets/images/brands/38.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=39139',
            icon: '/assets/images/brands/39.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=24302\n',
            icon: '/assets/images/brands/40.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=609\n',
            icon: '/assets/images/brands/41.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=42577\n',
            icon: '/assets/images/brands/42.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=354\n',
            icon: '/assets/images/brands/43.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=22030\n',
            icon: '/assets/images/brands/45.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=41353',
            icon: '/assets/images/brands/46.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=867\n',
            icon: '/assets/images/brands/47.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=39551\n',
            icon: '/assets/images/brands/48.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=740\n',
            icon: '/assets/images/brands/49.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=798\n',
            icon: '/assets/images/brands/50.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=10181\n',
            icon: '/assets/images/brands/51.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=42581\n',
            icon: '/assets/images/brands/52.png?v=18',
        },
        {
            url: 'https://emall.by/actions/lucky-goods?brands=26873\n',
            icon: '/assets/images/brands/54.png?v=18',
        },
    ]
}